<template>
    <div>
        <form @submit.prevent="submitDeposit">
            <div class="row">
                <div class="col-12 col-lg">
                    <div class="form-group">
                        <label class="form-label">Set Deposit</label>
                        <div class="input-group bg-white shadow-inset-2 mb-2">
                            <div class="input-group-prepend">
                                <span class="input-group-text bg-transparent border-right-0" style="min-width: 120px">
                                    Amount
                                </span>
                            </div>
                            <input type="number" class="form-control bg-transparent pl-3" v-model="amount" @keydown="isPositiveNumber($event)">
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="form-label">Bank Info</label>
                        <div class="input-group bg-white shadow-inset-2 mb-2">
                            <div class="input-group-prepend w-100">
                                <span class="input-group-text bg-transparent border-right-0" style="min-width: 120px">
                                    Bank
                                </span>
                                <multiselect v-model="bank" label="name" track-by="bankID" :options="banks" :searchable="true" :show-labels="false" openDirection="below" @select="selectBank">
                                    <template slot="option" slot-scope="{ option }">{{option.name}}</template>
                                </multiselect>
                            </div>
                        </div>
                        <div class="input-group bg-white shadow-inset-2 mb-2">
                            <div class="input-group-prepend">
                                <span class="input-group-text bg-transparent border-right-0" style="min-width: 120px">
                                    Bank Number
                                </span>
                            </div>
                            <input type="text" class="form-control bg-transparent pl-3" v-model="bankAccNumber">
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="form-label">Touch 'n Go Info</label>
                        <div class="input-group bg-white shadow-inset-2 mb-2">
                            <div class="input-group-prepend">
                                <span class="input-group-text bg-transparent border-right-0" style="min-width: 120px">
                                    Phone Number
                                </span>
                            </div>
                            <input type="tel" class="form-control bg-transparent pl-3" v-model="mobileNumber" @keyup="contactValidation">
                        </div>
                        <div v-if="contactError" class="error-validation">{{ contactError }}</div>
                    </div>
                </div>
                <div class="d-none d-lg-block col-auto border-right"></div>
                <div class="d-none d-lg-block col-auto"></div>
                <div class="col-12 col-lg mt-3 mt-lg-0">
                    <label class="form-label">Payment QR Code</label>
                    <div id="imageContainer" v-if="url" class="text-center mt-3">
                        <div class="text-right mb-2 mr-2">
                            <button class="btn btn-sm btn-outline-primary" type="button"
                                :title="$t('header.delete_image')"
                                @click="showDeleteImageModal">
                                <span class="fal fa-trash"></span>
                            </button>
                        </div>
                        <a :title="$t('button_link.click_upload')" class="m-auto">
                            <img class="img-fluid img-thumbnail" :src="url" />
                        </a>
                    </div>
                    <div v-else>
                        <vue-dropzone
                            ref="dropzone"
                            class="text-center"
                            id="dropzoneAdd"
                            :options="dropOptions"
                            @vdropzone-success="dropzoneAdd">
                        </vue-dropzone>
                    </div>
                </div>
            </div>
            <div class="text-left mt-3 mb-3">
                <button type="submit" class="btn border-0 btn-primary btn-padding waves-effect waves-themed">{{ $t('button_link.save') }}</button>
            </div>
        </form>
        <deleteModal ref="deleteModal" @performConfirmAction="deleteImage"></deleteModal>
    </div>
</template>

<script>
import _ from 'lodash';
import { handleSessionExpired } from './../../../../assets/js/dashboard/dashboard'
import { contactValidation, isPositiveNumber } from './../../../../assets/js/dashboard/utilities'
import vueDropzone from "vue2-dropzone";
import DeleteModal from './../../Delete_Modal'

export default {
    name: 'deposit',
    components: {
        vueDropzone, 
        DeleteModal,
    },
    props: {
        banks: { type: Array },
    },
    data: function () {
        return {
            deposit: {},
            
            amount: '',
            bank: {},
            bankAccNumber: '',
            mobileNumber: '',
            url: '',

            contactError: '',

            dropOptions: {
                url: this.$api.API_IMAGE,
                addRemoveLinks: true,
                maxFiles: 1,
                paramName: 'filename',
                headers: {
                    token: this.$util.getSessionToken()
                }
            },
        }
    },
    methods: {
        isPositiveNumber(e) {
            setTimeout(this.validateForm, 100)
            return isPositiveNumber(e);
        },
        contactValidation() {
            let err = contactValidation(this.mobileNumber)
            this.contactError = err ? this.$i18n.t('message.contact_validation.phone_number', { 'error': this.$i18n.t(`message.contact_validation.error.${err}`) }) : ''
        },

        selectBank(e) {
            this.bank = e
        },
        showDeleteImageModal() {
            var title = this.$i18n.t('header.delete_image')
            var message = this.$i18n.t('message.confirmation.delete_image')
            this.$refs.deleteModal.showModal(title, message)
        },
        dropzoneAdd(file, response) {
            this.url = response.path
        },

        setDeposit(deposit) {
            this.deposit = deposit

            this.amount = this.deposit.amount
            this.bank = this.banks.find(k => k['bankID'] === this.deposit.bankID)
            this.bankAccNumber = this.deposit.bankAccNumber
            this.mobileNumber = this.deposit.mobileNumber
            this.url = this.deposit.url
        },
        
        deleteImage() {
            this.url = ''
            this.$refs.deleteModal.toggleModal = false
        },
        submitDeposit() {
            let deposit = {}
            deposit.amount = this.amount
            deposit.bankID = (this.bank || {})['bankID']
            deposit.bankAccNumber = this.bankAccNumber
            deposit.mobileNumber = this.mobileNumber
            deposit.url = this.url

            this.$emit('submitDeposit', deposit);
        },
    },
    async mounted() {
    }
}
</script>
<style scoped>
.error-validation {
    font-size: 0.6875rem;
    margin-top: 0.325rem;
    color: #fd3995;
}
</style>